"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NpmTypes = exports.ScoreCategoryName = void 0;
var ScoreCategoryName;
(function (ScoreCategoryName) {
    ScoreCategoryName["Quality"] = "quality";
    ScoreCategoryName["Maintenance"] = "maintenance";
    ScoreCategoryName["Popularity"] = "popularity";
})(ScoreCategoryName = exports.ScoreCategoryName || (exports.ScoreCategoryName = {}));
var NpmTypes;
(function (NpmTypes) {
    NpmTypes["None"] = "none";
    NpmTypes["Flow"] = "flow";
    NpmTypes["TypeScript"] = "ts";
    NpmTypes["DefinitelyTyped"] = "dt";
})(NpmTypes = exports.NpmTypes || (exports.NpmTypes = {}));
//# sourceMappingURL=mod.js.map